import React, { Component } from 'react';
import PropTypes from 'prop-types';

import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
import intlShape from '@/shared/utils/intlShape';
import messages from '../documentMessages';

export default class DownloadDocumentZipModal extends Component {
  state = {
    useFolderStructure: true,
    prefixFilenameWithDocumentDate: false,
    groupByRelation: true,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { useFolderStructure, prefixFilenameWithDocumentDate, groupByRelation } = this.state;
    const { onSave } = this.props;

    return onSave({ useFolderStructure, prefixFilenameWithDocumentDate, groupByRelation });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const { useFolderStructure, prefixFilenameWithDocumentDate, groupByRelation } = this.state;
    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.DownloadAsZip)}
        show={show}
        onClose={this.closeModal}
        disabled={false}
        onSave={() => this.onSave()}
      >
        <div className="row">
          <div className="form-horizontal">
            <div className="form-group">
              <div className="col-sm-11 col-sm-offset-1">
                <Checkbox
                  onClick={() =>
                    this.setState({
                      groupByRelation: !groupByRelation,
                    })
                  }
                  text={intl.formatMessage(messages.GroupByRelation)}
                  value={groupByRelation}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-11 col-sm-offset-1">
                <Checkbox
                  onClick={() => this.setState({ useFolderStructure: !useFolderStructure })}
                  text={intl.formatMessage(messages.DownloadZipWithFolderStructureYesNo)}
                  value={useFolderStructure}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-11 col-sm-offset-1">
                <Checkbox
                  onClick={() =>
                    this.setState({
                      prefixFilenameWithDocumentDate: !prefixFilenameWithDocumentDate,
                    })
                  }
                  text={intl.formatMessage(messages.PrefixFilenameWithDocumentDate)}
                  value={prefixFilenameWithDocumentDate}
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
